"use client";

import { Fragment, PropsWithChildren } from "react";
import localFont from "next/font/local";
import Script from "next/script";
import { Toaster } from "sonner";
import { CLARITY_PROJECT_ID, GA_TRACKING_ID } from "@/common/constants";
import ProviderConfig from "@/common/providers/Config/provider";
import { QueryProvider } from "@/common/providers/QueryClient/provider";
import ReduxProvider from "@/common/providers/Redux/provider";
import StagingProvider from "@/common/providers/Staging";
import { withProviders } from "@/common/providers/withProviders";
import { env } from "@/env";
const ravifont = localFont({
  src: "../../../../public/fonts/RaviFaNumVF.woff2",
  variable: "--font-ravifont",
  weight: "100 900"
});
const RootLayoutModule = ({
  children
}: PropsWithChildren) => {
  return <html className={`${ravifont.className}`} data-sentry-component="RootLayoutModule" data-sentry-source-file="layout.tsx">
      <head>
        {env.isProduction ? <Script id="google-tag-manager">
            {`
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
              new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
              j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
              'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
              })(window,document,'script','dataLayer','GTM-NG5JNQPT');
            `}
          </Script> : null}
      </head>
      <meta name="theme-color" content="#025951" data-sentry-element="meta" data-sentry-source-file="layout.tsx" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" data-sentry-element="meta" data-sentry-source-file="layout.tsx" />
      <body dir="rtl">
        <ReduxProvider data-sentry-element="ReduxProvider" data-sentry-source-file="layout.tsx">
          {true ? <Fragment>
              <noscript>
                <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-NG5JNQPT" height="0" width="0" style={{
              display: "none",
              visibility: "hidden"
            }}></iframe>
              </noscript>
              <Script src={`https://www.googletagmanager.com/gtag/js?id=${GA_TRACKING_ID}`} strategy="afterInteractive" />
              <Script id="google-analytics" strategy="afterInteractive">
                {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());

            gtag('config', '${GA_TRACKING_ID}', {
              page_path: window.location.pathname,
            });
          `}
              </Script>
              <Script id="microsoft-clarity" strategy="afterInteractive">
                {`
            (function(c,l,a,r,i,t,y){
              c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
              t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
              y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
            })(window, document, "clarity", "script", "${CLARITY_PROJECT_ID}");
          `}
              </Script>
            </Fragment> : null}

          <ProviderConfig data-sentry-element="ProviderConfig" data-sentry-source-file="layout.tsx">
            {children}
            <div id="modal"></div>
          </ProviderConfig>
          <Toaster richColors duration={1000} className="!font-abar" position="top-center" toastOptions={{
          classNames: {
            toast: "direction-rtl !gap-3 !cursor-default !font-['ravifont']"
          }
        }} data-sentry-element="Toaster" data-sentry-source-file="layout.tsx" />
          <Script id="goftino" strategy="afterInteractive" type="text/javascript" data-sentry-element="Script" data-sentry-source-file="layout.tsx">
            {`!function(){var i="nMqecw",a=window,d=document;function g(){var g=d.createElement("script"),s="https://www.goftino.com/widget/"+i,l=localStorage.getItem("goftino_"+i);g.async=!0,g.src=l?s+"?o="+l:s;d.getElementsByTagName("head")[0].appendChild(g);}"complete"===d.readyState?g():a.attachEvent?a.attachEvent("onload",g):a.addEventListener("load",g,!1);}();`}
          </Script>
          <Script id="goftino-ready" strategy="afterInteractive" data-sentry-element="Script" data-sentry-source-file="layout.tsx">
            {`if(window.innerWidth<769){
            window.addEventListener('goftino_ready', function () {
                Goftino.setWidget({
                    hasIcon: false,
                });
            });
        }`}
          </Script>
          <StagingProvider data-sentry-element="StagingProvider" data-sentry-source-file="layout.tsx" />
        </ReduxProvider>
      </body>
    </html>;
};
export default withProviders(RootLayoutModule)(QueryProvider);